import { names } from 'utilities/constants';

const competenceConstants = {
    ...names(
        'OPEN_SCHEDULED_COMPETENCE_DIALOG',
        'CLOSE_SCHEDULED_COMPETENCE_DIALOG',
        'OPEN_COMPETENCE_SELECTION_SCREEN',
        'CLOSE_COMPETENCE_SELECTION_SCREEN',
        'SELECT_PENDING_COMPETENCE_LIST',
        'SELECT_AVAILABLE_COMPETENCE_LIST',
        'CHOOSE_COMPETENCE',
        'OPEN_SCANNING_PAGE',
        'CLOSE_SCANNING_PAGE',

        'OPEN_AUTH_CHOOSER',
        'CLOSE_AUTH_CHOOSER',
        'OPEN_QR_DIALOG',
        'OPEN_QR_SCANNER_DIALOG',
        'CLOSE_QR_DIALOG',
        'OPEN_MANUAL_LOOKUP_DIALOG',
        'CLOSE_MANUAL_LOOKUP_DIALOG',
        'SELECT_COMPETENCE_AND_AWARD',

        'OPEN_GROUP_EVIDENCE_DIALOG',
        'CLOSE_GROUP_EVIDENCE_DIALOG',
        'SELECT_GROUP_EVIDENCE'
    )
};

export default competenceConstants;